<template>
  <div class="clientsEdit">
    <div class="pageContent">
      <heading type="h1">Edit <span v-if="!loading">{{ client.name }}</span></heading>
      <spinner v-if="loading" />
      <div v-if="!loading">
        <router-link class="clientsEdit__logoLink" :to="{ path: `/client/${this.clientId}` }">
          <client-logo :path="client.logo"/>
        </router-link>
        <div class="row">
          <div class="col-sm-2">
            <upload-file name="Upload Logo" :ctaText="uploadLogoText" @input="onUploadLogo" acceptedFileType="image/*"/>
          </div>
          <div v-if="hasLogo" class="col-sm-2 clientsEdit__removeLogo">
            <button-cta :onClick="removeLogo">Remove logo</button-cta>
          </div>
        </div>
        <client-form :client="client" :submit="save" @loading="onLoadingStatus"/>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import ClientForm from '@/components/ClientForm/client-form'
import UploadFile from '@/components/UploadFile/upload-file'
import ClientLogo from '@/components/ClientLogo/client-logo'

import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {pageMixin} from '@/mixins/pageMixin'

export default {
  name: 'ClientsEdit',
  mixins: [clientMixin, notificationMixin, pageMixin],
  components: {
    UploadFile,
    Heading,
    ButtonCta,
    Spinner,
    ClientForm,
    ClientLogo
  },
  data: () => ({
    loading: true
  }),
  created () {
    this.getClient(this.clientId).then(() => {
      this.loading = false
    }, error => {
      this.addNotification('danger', error)
    })
  },
  computed: {
    uploadLogoText () {
      return `${this.client && this.client.logo ? 'Change' : 'Upload'} logo`
    },
    hasLogo () {
      return this.client.logo && this.client.logo.length > 0
    }
  },
  methods: {
    save () {
      this.loading = true
      this.updateClient(this.client).then(() => {
        this.addNotification('success', `'${this.client.name} client' Successfully updated.`)
        this.loading = false
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    },
    onUploadLogo (e) {
      this.loading = true
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      formData.append('file', files[0])
      const data = {
        id: this.clientId,
        file: formData
      }
      this.uploadImage(data).then(() => {
        this.getClient(this.clientId).then(() => {
          this.addNotification('success', 'Logo successfully uploaded.')
          this.loading = false
        }, error => {
          this.loading = false
          this.addNotification('danger', error)
        })
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    },
    removeLogo () {
      this.deleteImage(this.clientId).then(() => {
        this.getClient(this.clientId).then(() => {
          this.addNotification('success', 'Logo successfully deleted.')
          this.loading = false
        }, error => {
          this.loading = false
          this.addNotification('danger', error)
        })
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
    .clientsEdit {
      &__removeLogo {
        margin-top: 24px;
      }
      &__logoLink {
        display: inline-block;
        max-width: 100%;
        &:hover {
          text-decoration: none;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/client/clients-edit.vue